import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import React, { useState } from "react";
import { ShowTimesheet } from "../showTimesheet";

const TimesheetSection = (props: any) => {
  const timesheetData = [
    { date: "2025-01-01", hours: 8, project: "Tech Corp" },
    { date: "2025-01-02", hours: 7, project: "Tech Corp" },
  ];

  const [selectedTimesheet, setSelectedTimesheet] = useState<any>(null);

  const onHide = () => {
    props.hideDialog();
    setSelectedTimesheet(null);
  };

  const onEdit = (timesheet: any) => {
    setSelectedTimesheet(timesheet);
    props.showDialog();
  };

  const editButtonTemplate = (rowData: any) => {
    return (
      <Button
        label="Edit"
        icon="pi pi-pencil"
        onClick={() => onEdit(rowData)}
        className="p-button-secondary"
      />
    );
  };

  return (
    <div>
      <Dialog visible={props.open} style={{ width: "80vw" }} header="My Timesheets" modal className="p-fluid" onHide={onHide}>
        {/* <Card title="Timesheet">
          <DataTable value={timesheetData}>
            <Column field="date" header="Date" />
            <Column field="hours" header="Hours Worked" />
            <Column field="project" header="Project" />
            <Column body={editButtonTemplate} header="Actions" />
          </DataTable>
        </Card> */}
        <ShowTimesheet  is_Create={true} is_View={true} is_Update={true} is_Export={true}  />
      </Dialog>
    </div>
  );
};

export default TimesheetSection;
